import React, { useState } from 'react';
import HistoryOrder from '../components/HistoryOrder';
import MarketHistory from '../components/MarketHistory';
import MarketNews from '../components/MarketNews';
import MarketPairs from '../components/MarketPairs';
import MarketTrade from '../components/MarketTrade';
import OrderBook from '../components/OrderBook';
import TradingChartDark from '../components/TradingChartDark';

export default function Exchange() {
  const [symbol, setSymbol] = useState("BINANCE:BTCUSDT");

  return (
    <div className="container-fluid mtb15 no-fluid">
      <div className="row sm-gutters">
        <div className="col-sm-12 col-md-3">
          <MarketPairs onSelectSymbol={setSymbol} />
        </div>

        <div className="col-sm-12 col-md-6">
          <TradingChartDark symbol={symbol} />
          <MarketTrade />
        </div>

        <div className="col-md-3">
          <OrderBook />
          <MarketHistory />
        </div>

        <div className="col-md-3">
          <MarketNews />
        </div>

        <div className="col-md-9">
          <HistoryOrder />
        </div>
      </div>
    </div>
  );
}
